import { Pressable, Card, VStack, HStack } from "@gluestack-ui/themed";

import { Icon } from "@repo/core/components/core/Icon";
import { IconNames } from "@repo/core/components/core/Icon/types";

import { ShortcutsProps, PressableProps } from "./types";
import { Text } from "@repo/core/components/core/Text";

export const Shortcuts = ({ items, title }: ShortcutsProps) => {
  return (
    <VStack flex={1} w="$full" $web-md-w="80%" space="md">
      {title && (
        <Text flex={1} fontSize="$sm" fontWeight={500} color="$secondary800">
          {title}
        </Text>
      )}

      <HStack
        w="$full"
        alignItems={items.length > 3 ? "flex-start" : "center"}
        justifyContent={items.length > 3 ? "space-between" : "flex-start"}
        space="md"
      >
        {items?.map((item) => {
          const borderColor =
            item.type === "primary" ? "$primary700" : "$secondary700";
          const bgColor =
            item.type === "primary" ? "$primary50" : "$secondary50";
          const iconColor =
            item.type === "primary" ? "$primary700" : "$secondary700";
          return (
            <Pressable
              key={item.label}
              onPress={item.onPress}
              alignItems="center"
              zIndex={2}
              justifyContent="center"
              maxWidth="$20"
            >
              {({ hovered, pressed, focused }: PressableProps) => {
                return (
                  <>
                    <Card
                      bgColor={bgColor}
                      alignItems="center"
                      justifyContent="center"
                      borderWidth={hovered || pressed || focused ? "$2" : "$0"}
                      borderColor={borderColor}
                      shadowOffset={{ width: 0, height: 0 }}
                      borderRadius="$lg"
                      zIndex={2}
                      w="$16"
                      h="$16"
                    >
                      <Icon
                        name={item.icon as IconNames}
                        size={24}
                        color={iconColor}
                      />
                    </Card>
                    <Text
                      mt="$2"
                      fontWeight={500}
                      color="$textLight800"
                      fontSize="$2xs"
                      textAlign="center"
                    >
                      {item.label}
                    </Text>
                  </>
                );
              }}
            </Pressable>
          );
        }) || null}
      </HStack>
    </VStack>
  );
};
